import { DomainError } from "./DomainError";

export class BusinessRuleError extends DomainError {}
